let liveHost =
  window.location.host.split(".")[window.location.host.split(".").length - 2] +
  "." +
  window.location.host.split(".")[window.location.host.split(".").length - 1];

// local host name here
let localHost = liveHost[1];

//Base URL
// export const BASE_URL = "https://gateway.reachiq.ai";
export const BASE_URL = process.env.REACT_APP_GATEWAY;
export const PORT = "";
export const HOSTNAME = localHost;
// const hosts = HOSTNAME.trim()?.split(".");
const host = "reachiq.ai";
export const HOST_URL = host;
export const protocol = "http://";

//Endpoints change for remote origin change

export const CONNECTOME_LINK = "https://connectomeinc.com/"

export const authEndpoints = {
  connectInboxVerify: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "connect-inbox",
  register: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "register",
  login: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "login",
  verifyEmail: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "verify-email",
  verifyUserEmail: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "verify-user-email",
  verifyDomain: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "validate-subdomain",
  logout: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "logout",
  checkLogin: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "refresh-token",
  sendMailForResetPassword: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "reset-password",
  verifyTokenForResetPassword: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "reset-password/verify-token",
  resetPassword: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "update-password",
  googleTokenVerify: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "google-registered",
  microsoftTokenVerify: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "microsoft-registered",
  loginForTenant: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "login-for-tenant",
  googleSignup: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "google/tenant-register",
  googleLogin: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "google/user-verify-code",
  microsoftLogin: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "google/user-verify-code",
  verifyRegistrationCode: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "validate-beta-invitation-token",
  googleAuthToken: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "google-signup?token=",
  googleAuthTokenWithoutPrefix: "auth/google-signup?token=",
};

// static links

export const PRIVACY_POLICY_LINK = "http://reachiq.ai/privacy-policy";
export const TERMS_SERVICE_LINK = "https://reachiq.ai/terms-of-service/";
export const DO_NOT_SELL_LINK = "https://reachiq.ai/do-not-sell-my-information";

export const REACHIQ_HOME = "https://reachiq.ai";
export const GET_EARLY_ACCESS = "https://reachiq.ai/get-early-access";

export const HTTP = "http://";

// ─── New Onboarding v2 API endpoints ─────────────────────────────────────────
export const signupEndpoints = {
  start:          process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "signup/start",
  setPlan:        process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "signup/set-plan",
  checkSubdomain: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "signup/check-subdomain",
  setSubdomain:   process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "signup/set-subdomain",
  verifyEmail:    process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "signup/verify-email",
  resendVerification: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "signup/resend-verification",
  resetDraftPassword: process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "signup/reset-draft-password",
  salesLead:      process.env.REACT_APP_ENDPOINT_PREFIX_AUTH + "sales-lead",
};

export const paymentEndpoints = {
  publicPackages: "payment/api/v2.0/package/public-list",
  createSession:  "payment/api/v2.0/signup/create-session",
  trialToken:     "payment/api/v2.0/signup/trial-token",
  verifySession:  "payment/api/v2.0/signup/verify-session",
  claimFreePlan:  "payment/api/v2.0/signup/claim-free-plan",
};
// ─────────────────────────────────────────────────────────────────────────────
